/**
 * Feature Request Modal Handler
 * Handles form submission to Klaviyo via /klaviyo/metric endpoint
 */

class FeatureRequestForm {
  constructor() {
    this.form = document.getElementById('feature-request-form');
    this.statusDiv = document.getElementById('feature-request-status');
    this.modal = document.getElementById('feature-request-modal');
    
    if (!this.form) return;
    
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    
    // Handle cancel button
    const cancelBtn = this.form.querySelector('[data-close-modal]');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        if (this.modal && this.modal.hide) {
          this.modal.hide();
        }
      });
    }
  }
  
  async handleSubmit(e) {
    e.preventDefault();
    
    const submitBtn = this.form.querySelector('.feature-request-form__submit');
    const formData = new FormData(this.form);
    
    // Get form values
    const email = formData.get('email');
    const title = formData.get('title');
    const description = formData.get('description');
    const priority = formData.get('priority');
    
    // Disable submit button
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }
    
    try {
      const apiBaseUrl = window.MAGNOLIA?.apiBaseUrl || 'https://magnolia-memorial-api.vercel.app';
      const response = await fetch(`${apiBaseUrl}/klaviyo/metric`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          metric: 'Feature Request',
          email: email,
          properties: {
            title: title,
            description: description,
            priority: priority,
            funeral_home: window.funeralHome || '',
            account_role: window.accountRole || '',
            submitted_at: new Date().toISOString()
          }
        })
      });
      
      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }
      
      const result = await response.json();
      
      // Show success message
      this.showStatus('success', 'Thank you! Your feature request has been submitted.');
      
      // Reset form after short delay
      setTimeout(() => {
        this.form.reset();
        this.hideStatus();
        if (this.modal && this.modal.hide) {
          this.modal.hide();
        }
      }, 2000);
      
    } catch (error) {
      console.error('Feature request submission error:', error);
      this.showStatus('error', 'Sorry, there was an error submitting your request. Please try again.');
    } finally {
      // Re-enable submit button
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Request';
      }
    }
  }
  
  showStatus(type, message) {
    if (!this.statusDiv) return;
    
    this.statusDiv.textContent = message;
    this.statusDiv.className = `feature-request-form__status ${type}`;
    this.statusDiv.hidden = false;
  }
  
  hideStatus() {
    if (!this.statusDiv) return;
    this.statusDiv.hidden = true;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FeatureRequestForm();
  });
} else {
  new FeatureRequestForm();
}
